import { Component, OnInit, ViewChild } from "@angular/core";
import { LeadsService } from "../services/lead-service/lead-service.service";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ReservationService } from "../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "../services/shared/error-handler.service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import { PaginationComponent } from "../layout/pagination/pagination.component";

@Component({
  selector: "app-client-statements",
  templateUrl: "./client-statements.component.html",
  styleUrls: ["./client-statements.component.css"],
})
export class ClientStatementsComponent implements OnInit {
  @ViewChild("paginationRef") paginationRef: PaginationComponent;
  filter_collapsed = true;
  clients_raw_data;
  filterActive = false;
  is_refreshing = false;
  clients: any;
  agents: any[] = [];
  paginationFilters: any = {};
  filterForm: FormGroup;

  constructor(
    private leadService: LeadsService,
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForms();
  }

  ngOnInit() {
    // this.getClientStatements();
    this.getAgents();
    if (
      ["keyword", "date_from", "date_to", "unit_serial", "agent_ids"].some(
        (f) => this.route.snapshot.queryParams[f]
      )
    ) {
      this.filterClients(false);
    } else {
      this.getClientStatements();
    }
  }

  createForms() {
    this.filterForm = this.fb.group({
      status: ["Closed"],
      with_finance: [1],
      keyword: [this.route.snapshot.queryParams.keyword || ""],
      date_from: [this.route.snapshot.queryParams.date_from || ""],
      date_to: [this.route.snapshot.queryParams.date_to || ""],
      unit_serial: [this.route.snapshot.queryParams.unit_serial || ""],
      agent_ids: [this.parseAgentIdsFromQueryParams()],
    });
    this.paginationFilters = this.buildFilterPayload(this.filterForm.value);
  }

  getAgents() {
    this.leadService.getAgents().subscribe((res: any) => {
      const agents = Array.isArray(res) ? res : res && res.data ? res.data : [];
      this.agents = agents.map((agent) => this.normalizeAgentOption(agent));
    });
  }

  parseAgentIdsFromQueryParams() {
    const agentIds = this.route.snapshot.queryParams.agent_ids;
    if (!agentIds) {
      return [];
    }

    return `${agentIds}`
      .split(",")
      .map((id) => this.normalizeAgentId(id))
      .filter((id) => id !== null);
  }

  normalizeAgentOption(agent) {
    return {
      ...agent,
      id: this.normalizeAgentId(agent && agent.id),
      name:
        (agent && (agent.name || agent.full_name || agent.username || agent.text)) ||
        "",
    };
  }

  normalizeAgentId(agent) {
    const id = agent && typeof agent === "object" ? agent.id : agent;
    if (id === null || id === undefined || id === "") {
      return null;
    }

    const numericId = Number(id);
    return isNaN(numericId) ? id : numericId;
  }

  getClientStatements() {
    const { status } = this.filterForm.value;
    this.leadService.getLeads({ status }).subscribe((res: any) => {
      console.log(res);
      this.clients_raw_data = res;
      this.clients = res.data;
    });
  }

  viewClient(client) {
    this.router.navigate(["/pages/clients-statements", client.id]);
  }

  getNewRecord(event) {
    this.clients = event.data;
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }

  filter() {
    this.paginationFilters = this.buildFilterPayload(this.filterForm.value);
    this.setQueryParams(this.paginationFilters);
    // Ensure first submit uses the latest filters immediately.
    this.paginationRef.filters = this.paginationFilters;
    this.paginationRef.page = 1;
    this.paginationRef.infinite();
  }

  resetFilter() {
    this.createForms();
    this.paginationRef.filters = this.paginationFilters;
    this.paginationRef.page = 1;
    this.paginationRef.resetFilters();
  }

  buildFilterPayload(formModel: any = {}) {
    const payload: any = { ...formModel };
    const selectedAgentIds = Array.isArray(payload.agent_ids)
      ? payload.agent_ids
          .map((agent) => this.normalizeAgentId(agent))
          .filter((agentId) => agentId !== null)
      : [];

    if (selectedAgentIds.length === 1) {
      payload.agent_id = selectedAgentIds[0];
      payload.agent_ids = null;
    } else if (selectedAgentIds.length > 1) {
      payload.agent_ids = selectedAgentIds.join(",");
      payload.agent_id = null;
    } else {
      payload.agent_id = null;
      payload.agent_ids = null;
    }

    return payload;
  }

  filterClients(cache = true) {
    const formModel: any = this.buildFilterPayload(this.filterForm.value);
    this.paginationFilters = formModel;

    console.log(formModel);
    if (cache) {
      this.setQueryParams(formModel);
    }

    this.leadService.getLeads(formModel).subscribe((res: any) => {
      this.clients_raw_data = res;
      this.clients = res.data;
    });
  }

  // cache filters
  setQueryParams(params = {}) {
    let data: any = {};

    ["keyword", "date_from", "date_to", "unit_serial", "agent_ids"].map((f) => {
      if (params[f]) {
        data[f] = params[f];
      }
    });
    console.log(data);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: data,
      replaceUrl: true,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/client-statements/client-statements.component.ts